import qs from 'qs';

import { DEFAULT_DISCOVER_URL } from '../../../../const';
import { translate } from '../../../../utils/helpers';
import { HITS_TYPES } from '../../const';

export const getNavigationArray = (selectedTab) => {
  let navigationArr = [
    {
      title: translate('page.discover.discover'),
      url: DEFAULT_DISCOVER_URL,
    },
  ];

  let searchObj;

  switch (selectedTab) {
    case HITS_TYPES.VIDEO: {
      searchObj = {
        title: translate('page.discover.videoModules'),
      };
      break;
    }
    case HITS_TYPES.PATHWAY: {
      searchObj = {
        title: translate('page.discover.pathways'),
      };
      break;
    }
    case HITS_TYPES.NEWS: {
      searchObj = {
        title: translate('page.discover.text'),
      };
      break;
    }
    case HITS_TYPES.GLOSSARY: {
      searchObj = {
        title: translate('page.discover.glossary'),
      };
      break;
    }
    default: {
      searchObj = {
        title: translate('page.discover.search'),
      };
      break;
    }
  }

  navigationArr.push(searchObj);

  return navigationArr;
};

export const createURL = (state) => `?${qs.stringify(state)}`;
